module.exports = __webpack_public_path__ + "static/media/doc.3f8d1fb1.svg";